import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import LineasCreate from "./LineasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoLineas() {
  const { user } = useContext(AuthContext);
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [lineas, setLineas] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  // sin mayusculas ni acentos: "genérica" encuentra "Generica"
  const normaliza = (t) =>
    String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const filtradas = lineas.filter((a) => normaliza(a.name).includes(normaliza(busqueda.trim())));
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
    const [factor1, setFactor1] = useState(0);
    const [factor2, setFactor2] = useState(0);
    const [factor3, setFactor3] = useState(0);
    const [factor4, setFactor4] = useState(0);
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allLineas = response.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editLinea(event) {
    event.preventDefault();
    const URL_LINEAS_EDIT = `${process.env.REACT_APP_URL_LINEAS}/${idEdit}`;
    axios
      .patch(
        URL_LINEAS_EDIT,
        {
          name,
          factor1,
          factor2,
          factor3,
          factor4,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Linea',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, factor1, factor2, factor3, factor4) {
        setName(name);
        setFactor1(factor1);
        setFactor2(factor2);
        setFactor3(factor3);
        setFactor4(factor4);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_articulos ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Lineas</h3>
                    <Input
                      type="text"
                      placeholder="Buscar..."
                      value={busqueda}
                      onChange={(e) => setBusqueda(e.target.value)}
                      style={{ marginBottom: 8 }}
                    />
                    {busqueda.trim() !== "" && (
                      <small style={{ color: "#64748b" }}>
                        {filtradas.length} de {lineas.length}
                      </small>
                    )}
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Nombre</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtradas
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.name}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.name, a.factor1, a.factor2, a.factor3, a.factor4)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <LineasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Lineas</ModalHeader>
        <ModalBody>
          <Row>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          </Row>
                      {/* <Row>
                        <Col md={6}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            Factor 1
                          </Label>
                          <Input
                            type="number"
                            placeholder="Factor 1"
                            value={factor1}
                            required
                            onChange={(e) => {
                              setFactor1(e.target.value);
                            }}
                          />
                        </Col>
                        <Col md={6}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            Factor 2
                          </Label>
                          <Input
                            type="number"
                            placeholder="Factor 2"
                            value={factor2}
                            required
                            onChange={(e) => {
                              setFactor2(e.target.value);
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            Factor 3
                          </Label>
                          <Input
                            type="number"
                            placeholder="Factor 3"
                            value={factor3}
                            required
                            onChange={(e) => {
                              setFactor3(e.target.value);
                            }}
                          />
                        </Col>
                        <Col md={6}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            Factor 4
                          </Label>
                          <Input
                            type="number"
                            placeholder="Factor 4"
                            value={factor4}
                            required
                            onChange={(e) => {
                              setFactor4(e.target.value);
                            }}
                          />
                        </Col>
                      </Row> */}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editLinea}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoLineas;
